export const login = {
  login: 'Log in',
  email: 'Email',
  password: 'Password',
  sendEmail: 'Send email',
  forgotPasswordPara: 'Forgot your password?',
  resetPasswordHeader: 'Reset password',
  resetPasswordEmailSent:
    'If an account with this email exists, we have sent a password reset link to it.',
  setNewPassword: 'Set a new password',
  newPassword: 'New password',
  newPasswordConfirmation: 'Confirm new password',
  passwordChanged: 'Password has been changed. You can now log in.',
  invalidResetLink: 'Invalid password reset link',
  passwordMustMatch: 'Passwords must match',
  profile: 'Profile',
  logout: 'Log out',
  title: 'Login',
  approved: 'Approve',
  regenerateChallenge: 'Regenerate authentication code',
}
